import React, { useEffect, useState } from "react";
import moment from "moment";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Translation
import { useTranslation } from "react-i18next";

// APIs
import getItdr from "api/itdr/getItdr";

// MUI
// import Tooltip from "@mui/material/Tooltip";
import { /* Icon, */ IconButton } from "@mui/material";
// import { useMaterialUIController } from "context";
import SweetAlert from "react-bootstrap-sweetalert";

const Itdr = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [details, setDetails] = useState(null);
  //   const [controller] = useMaterialUIController();
  //   const { user } = controller;

  const getData = async () => {
    try {
      const { results } = await getItdr();
      //   console.log("results", results);
      setData(results);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {details ? (
        <SweetAlert
          style={{ display: "block", position: "relative", textAlign: "left" }}
          title={t("itdr.details")}
          onConfirm={() => {
            setDetails(null);
          }}
          confirmBtnText={t("ok")}
          confirmBtnCssClass="popupCloseButton"
          confirmBtnStyle={{
            boxShadow: "none",
          }}
        >
          <div
            style={{
              fontSize: "16px",
              lineHeight: "22px",
              whiteSpace: "pre-wrap",
              textAlign: "left",
            }}
          >
            {details}
          </div>
        </SweetAlert>
      ) : null}
      {/* Title */}
      <h2 className="page-title">ITDR</h2>

      {/* Page description */}
      <p style={{ fontSize: "small" }}>{t("itdr.page_description")}</p>

      {/* Table */}
      <div className="table_users_list" style={{ marginTop: "25px" }}>
        <table
          className="table-content"
          cellSpacing="0"
          cellPadding="0"
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <colgroup>
            <col style={{ width: 140 }} /> {/* date */}
            <col style={{ width: 180 }} /> {/* platform */}
            <col style={{ width: 110 }} /> {/* severity */}
            <col style={{ width: 120 }} /> {/* status */}
            <col />
            <col style={{ width: 150 }} /> {/* details */}
          </colgroup>

          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>{t("itdr.date")}</th>
              <th style={{ textAlign: "center" }}>{t("itdr.platform")}</th>
              <th style={{ textAlign: "center" }}>{t("itdr.severity")}</th>
              <th style={{ textAlign: "center" }}>{t("itdr.status")}</th>
              <th style={{ textAlign: "center" }}>{t("itdr.subject")}</th>
              <th style={{ textAlign: "center" }}>{t("itdr.details")}</th>
            </tr>
          </thead>

          <tbody>
            {data && data.length > 0
              ? data.map((incident) => (
                  <tr key={incident.id}>
                    <td>{moment(incident.date).format("DD/MM/YYYY")}</td>
                    <td title={incident.platform || ""}>{incident.platform || "N/A"}</td>
                    <td>{incident.severity || "N/A"}</td>
                    <td>{incident.status || "N/A"}</td>

                    <td title={incident.subject || ""}>
                      <span
                        style={{
                          display: "block",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {incident.subject || "N/A"}
                      </span>
                    </td>

                    <td>
                      {incident.body ? (
                        <IconButton
                          onClick={() => incident.body && setDetails(incident.body)}
                          className="default-button"
                          size="small"
                          disableRipple
                        >
                          {t("details")}
                        </IconButton>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default Itdr;
